import store from '@/store';

<template>
  <v-list class="n-lines">
    <v-list-tile>
      <v-list-tile-content>
        <v-list-tile-sub-title>
          <v-layout row>
            <v-flex>
              <template v-for="service in parking.features">
                <v-tooltip bottom class="mx-2" :key="service.alias">
                  <a :key="service.alias" slot="activator">
                    <img
                      style="margin-top:9px"
                      :class="{
                        smallIcon: $vuetify.breakpoint.xsOnly,
                        normalIcon: $vuetify.breakpoint.smAndUp
                      }"
                      :src="`${image(service.image)}`"
                    />
                  </a>
                  <span v-html="service.title"></span>
                </v-tooltip>
              </template>
            </v-flex>

            <v-flex xs5 md6 lg6 class="text-xs-right">
              <parking-detail-buttons
                :parking="parking"
              ></parking-detail-buttons>
              <parking-entry-buttons
                v-if="$vuetify.breakpoint.mdAndUp && countryHasBle"
                :parking="parking"
                :inverted="false"
              ></parking-entry-buttons>
            </v-flex>
          </v-layout>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import ParkingDetailButtons from '@/components/commons/ParkingDetailButtons';
import ParkingEntryButtons from '@/components/commons/ParkingEntryButtons';
import store from '@/store';

export default {
  name: 'ParkingServices',
  props: {
    parking: {
      type: Object,
      required: true
    }
  },
  components: {
    [ParkingDetailButtons.name]: ParkingDetailButtons,
    [ParkingEntryButtons.name]: ParkingEntryButtons
  },
  data() {
    return {
      countryHasBle: store.state.countrySelected.hasBle
    };
  },
  methods: {
    image(el) {
      return `${store.state.awsUrl}/${el.split('.')[0]}.svg`;
    }
  }
};
</script>

<style lang="scss" scoped>
.smallIcon {
  height: 25px;
}
.normalIcon {
  height: 30px;
}
</style>
